import { AspectRatio, calculateAspectRatio } from "./AspectRatio.js";


export enum SizingType {

    FULL_STATIC = 0,

}


export interface ContentSizing {

    getType(): SizingType;
    toString(): string
}


const scfmtRegex = /^([1-9][0-9]*)x([1-9][0-9]*)$/i;

export function parseStaticContentSizingFromString(s: string): StaticContentSizing {
    const matches = s.match(scfmtRegex);
    if(matches) {        
        return new StaticContentSizing(parseInt(matches[1]),parseInt(matches[2]));
    }
    return null;
}

export class StaticContentSizing implements ContentSizing{


    
    public readonly aspectRatio: AspectRatio;
    public readonly width: number;
    public readonly height: number;
    constructor(w: number, h: number) {
        this.width = Math.floor(w);
        this.height = Math.floor(h);
        this.aspectRatio = calculateAspectRatio(this.width,this.height);
    }
    getType(): SizingType {
        return SizingType.FULL_STATIC;
    }

    getArea(): number {
        return this.width * this.height;
    }

    isEmpty(): boolean {
        return this.getArea() <= 0;
    }

    rescaleVerticallyWithAspectRatio(ar: AspectRatio): StaticContentSizing {
        return new StaticContentSizing(this.width, this.width / ar.ratio);
    }

    rescaleHorizontallyWithAspectRatio(ar: AspectRatio): StaticContentSizing {
        return new StaticContentSizing(this.height * ar.ratio, this.height);
    }


    contains(other: StaticContentSizing): boolean {
        return this.width >= other.width && this.height >= this.height;
    }




    toString(): string {
        return `StaticSizing: ${this.width} x ${this.height} :: AspectRatio ${this.aspectRatio.toString()}`;

    }
    


}